import axios from "axios";
import React, { useEffect, useState } from "react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

const AlumniTestimonial = () => {
  const [alumniSection, setAlumniSection] = useState([]);
  useEffect(() => {
    axios.get("JSON/alumni.json").then((response) => {
      setAlumniSection(response.data[0]);
    });
  }, []);
  return (
    <>
      <section className="alumni-testimonial-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="section-head">
                <h3 className="section-head-title">
                  {alumniSection?.section_title}
                </h3>
                <p className="section-head-text">
                  {alumniSection?.section_detail}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="alumni-testimonial-slider">
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={30}
                  slidesPerView={3}
                  //   onSlideChange={() => console.log("slide change")}
                  //   onSwiper={(swiper) => console.log(swiper)}
                  loop={true}
                  autoplay={true}
                  pagination={{ clickable: true }}
                  breakpoints={{
                    // when window width is >= 320px
                    320: {
                      width: 320,
                      slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                      width: 768,
                      slidesPerView: 1,
                    },
                    // when window width is >= 1440px
                    1440: {
                      width: 1440,
                      slidesPerView: 3,
                    },
                  }}
                >
                  {alumniSection?.alumni_feedback?.map((SingleFeedback) => (
                    <SwiperSlide key={SingleFeedback.id}>
                      <div className="alumni-testimonial-card">
                        <div className="alumni-testi-top">
                          <div className="alumni-testi-top-content">
                            <i className="fi fi-bs-quote-right"></i>
                            <h4 className="alumni-testi-content-title">
                              {SingleFeedback.title}
                            </h4>
                            <p className="alumni-testi-content-text">
                              {SingleFeedback.detail}
                            </p>
                          </div>
                          <div className="alumni-testi-card-img">
                            <img src={SingleFeedback.img} alt="#" />
                          </div>
                        </div>
                        <div className="alumni-testi-bottom">
                          <h6 className="a-testi-student-name">
                            {SingleFeedback.name}
                          </h6>
                          <p className="a-testi-student-batch">
                            Batch: <span>{SingleFeedback.batch}</span>
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AlumniTestimonial;
